import React, { useEffect, useState } from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import styles from './styles.js';

const useStyles = createUseStyles(styles);

function Loader({ texts }) {
  const theme = useTheme();
  const classes = useStyles({ theme });

  const [loaderText, setLoaderText] = useState('');

  useEffect(() => {
    if (texts && texts.length) {
      let textID = '';
      for (let i = 0; i < texts.length; i++) {
        textID = setTimeout(() => {
          setLoaderText(texts[i]);
        }, 2000 * i);
      }
      return () => {
        clearTimeout(textID);
      };
    }
  }, []);

  return (
    <>
      <div className={classes.loaderContainer}>
        <div className={classes.spinner}></div>
        {texts && texts.length ? (
          <p className={classes.loaderDesc}> {loaderText}</p>
        ) : (
          ''
        )}
      </div>
    </>
  );
}

export default Loader;
